/// <reference path="../../node_modules/@types/sharepoint/index.d.ts" />
var TurismoRequiredModules = window["TurismoRequiredModules"] || [];
var TurismoModules = window["TurismoModules"] || {};
(function () {
    ExecuteOrDelayUntilBodyLoaded(function () {
        TurismoRequiredModules.push("MenuNavigation");
        TurismoRequiredModules.push("General");
        TurismoRequiredModules.forEach(function (element) {
            TurismoModules[element].init();
        });
    });
})();
/// <reference path="interfaces/module.ts" />
/// <reference path="../../node_modules/@types/jquery/index.d.ts"/>
(function () {
    "use strict";
    var AgendaEmpresario = (function () {
        var _AreaClickFn = function ($target) {
            var $pageElem = $(".agenda-empresario-page");
            $pageElem.find("#AreaBox-mobile").off("change");
            var targetFilter = $target.data("filter");
            if (targetFilter) {
                $.get(targetFilter, function (response) {
                    $pageElem.find("#Agenda").html(response);
                    var boxTarget = $pageElem.find($target.attr("box-toggle"));
                    $pageElem.find(".boxArea-toggle").removeClass("active");
                    if (boxTarget.hasClass("in")) {
                        boxTarget.siblings(".boxArea").removeClass("in");
                        boxTarget.removeClass("in");
                    }
                    $target.addClass("active");
                    boxTarget.siblings(".boxArea").removeClass("in").slideUp();
                    boxTarget.slideDown();
                    boxTarget.addClass("in");
                    $pageElem.find(".subAreas select").on("change", function (e) {
                        var $target = $(e.target);
                        var idx = $target.find("option:selected").index();
                        if (idx > 0) {
                            var targetFilter_1 = $target.val();
                            $pageElem.find(".itemBoxArea:not([data-subtipologia=\"" + targetFilter_1 + "\"])").hide();
                            $pageElem.find(".itemBoxArea[data-subtipologia=\"" + targetFilter_1 + "\"]").show();
                        }
                        else {
                            $pageElem.find(".itemBoxArea[data-subtipologia]").show();
                        }
                    });
                    _initMobileFilter();
                    (function ($) {
                        $.fn["hasScrollBar"] = function () {
                            return this.get(0).scrollHeight > Math.ceil(this.height());
                        };
                    })(jQuery);
                    setTimeout(function () {
                        var $workspace = $('#s4-workspace');
                        if ($workspace.hasScrollBar()) {
                            $workspace.animate({ scrollTop: "200px" });
                        }
                        else {
                            $("html, body").animate({ scrollTop: "200px" });
                        }
                    }, 200);
                });
            }
            else {
                var boxTarget = $pageElem.find("#boxArea");
                $pageElem.find(".boxArea-toggle").removeClass("active");
                if (boxTarget.hasClass("in")) {
                    boxTarget.siblings(".boxArea").removeClass("in");
                    boxTarget.removeClass("in");
                }
                _initMobileFilter();
            }
        };
        var _initMobileFilter = function () {
            var $pageElem = $(".agenda-empresario-page");
            $pageElem.find("#AreaBox-mobile").on("change", function (e) {
                var $target = $(e.target).find("option:selected");
                _AreaClickFn($target);
            });
        };
        var _initFilter = function () {
            var $pageElem = $(".agenda-empresario-page");
            $pageElem.find(".boxArea-toggle").on("click", function (e) {
                var $target = $(e.target);
                _AreaClickFn($target);
                return false;
            });
        };
        var _initPager = function () {
            $("#Agenda").on("click", "[id$=hlNextPage]", function (e) {
                e.preventDefault();
                var $target = $(e.target);
                $.get($target.data("nextpage"), function (response) {
                    var $response = $(response);
                    $response.appendTo($("#Agenda"));
                });
                $target.parents("div.col-xs-12").remove();
            });
        };
        var _privateInit = function () {
            _initFilter();
            _initMobileFilter();
            _initPager();
        };
        return {
            init: function () {
                _privateInit();
            }
        };
    })();
    (window["TurismoModules"] = window["TurismoModules"] || {})["AgendaEmpresario"] = AgendaEmpresario;
})();
/// <reference path="interfaces/module.ts" />
/// <reference path="../../node_modules/@types/jquery/index.d.ts"/>
(function () {
    "use strict";
    var TurismoAgenda = (function () {
        var _initFilter = function () {
            var $agendaDateNav = $("#agendaDateNav");
            var $agendaDateNavElems = $agendaDateNav.find("a.agendaDateNav_Link");
            $agendaDateNavElems.on("click", function (e) {
                e.preventDefault();
                var $target = $(e.target);
                var targetFilter = $target.data('filter');
                if (targetFilter) {
                    $.get(targetFilter, function (response) {
                        $("#Agenda").html(response);
                        $agendaDateNavElems.each(function () {
                            $(this).attr("aria-selected", "false");
                            $(this).removeClass("current-nav");
                        });
                        $target.attr("aria-selected", "true");
                        $target.addClass("current-nav");
                        window["__sharethis__"].initialize();
                    });
                }
            });
        };
        var _initPager = function () {
            $('#Agenda').on('click', '[id$=hlNextPage]', function (e) {
                e.preventDefault();
                var $target = $(e.target);
                $.get($target.data('nextpage'), function (response) {
                    var $response = $(response);
                    $response.appendTo($("#Agenda"));
                    window["__sharethis__"].initialize();
                });
                $target.parents('div.col-xs-12').remove();
            });
        };
        var _privateInit = function () {
            $("#agendaDateNavContents").owlCarousel({
                loop: false,
                dots: false,
                margin: 0,
                nav: true,
                responsiveClass: true,
                startPosition: 12,
                responsive: {
                    0: {
                        items: 1
                    },
                    600: {
                        items: 3
                    },
                    1000: {
                        items: 4
                    }
                }, navText: [
                    "<i class='turismo-nav-left' aria-hidden='true'></i>",
                    "<i class='turismo-nav-right' aria-hidden='true'></i>"
                ]
            });
            _initFilter();
            _initPager();
        };
        return {
            init: function () {
                _privateInit();
            }
        };
    })();
    (window["TurismoModules"] = window["TurismoModules"] || {})["TurismoAgenda"] = TurismoAgenda;
})();
/// <reference path="interfaces/module.ts" />
/// <reference path="../../node_modules/@types/jquery/index.d.ts"/>
(function () {
    "use strict";
    var CarrocelHomepage = (function () {
        var autoplayTimeout = 10e3;
        var _privateInit = function () {
            var owlCarousel = $(".institucional-carousel").owlCarousel({
                items: 1,
                lazyLoad: true,
                loop: true,
                center: true,
                dots: false,
                nav: false,
                video: true,
                margin: 0,
                autoplay: true,
                autoplayTimeout: autoplayTimeout,
                autoplaySpeed: 1500,
                URLhashListener: true,
                startPosition: 0,
                onInitialized: counter,
                onTranslated: counter
            });
            $(".institucional-carousel-nav li").on("mouseover", function (e) {
                var targetIndex = $(e.currentTarget).data("target");
                owlCarousel.trigger("to.owl.carousel", targetIndex);
                owlCarousel.trigger("stop.owl.autoplay");
            }).on("mouseout", function () {
                owlCarousel.trigger("play.owl.autoplay", [autoplayTimeout]);
            });
            function counter(event) {
                var element = event.target;
                var active = $(element).find(".owl-item.active > .institucionaltop-item");
                changedIndexNav(active.data("index"));
            }
            function changedIndexNav(item) {
                $(".institucional-carousel-nav").find(".item-nav").each(function () {
                    if (!($(this).data("target") !== item)) {
                        $(this).addClass("active");
                    }
                    else {
                        $(this).removeClass("active");
                    }
                });
                return false;
            }
        };
        return {
            init: function () {
                _privateInit();
            }
        };
    })();
    (window["TurismoModules"] = window["TurismoModules"] || {})["CarrocelHomepage"] = CarrocelHomepage;
})();
(function FAQ() {
    var init = function () {
        var $pageElem = $(".faqs-page");
        var $faqContainer = $pageElem.find("#FAQContainer");
        $pageElem.find(".container select#faq-topics").on("change", function (e) {
            var $target = $(e.target);
            var $selectedOption = $target.find("option:selected");
            var targetFilter = $selectedOption.data("filter");
            if (targetFilter) {
                $.get(targetFilter, function (response) {
                    $faqContainer.html(response);
                });
            }
            else {
                $faqContainer.html('');
            }
        });
    };
    ExecuteOrDelayUntilBodyLoaded(init);
})();
/// <reference path="interfaces/module.ts" />
/// <reference path="../../node_modules/@types/jquery/index.d.ts"/>
(function () {
    "use strict";
    var Galeria = (function () {
        var _privateInit = function () {
            $(".galeria-carousel").owlCarousel({
                items: 1,
                lazyLoad: true,
                loop: true,
                autoplay: true,
                nav: true,
                video: true,
                navText: [
                    "<i class='turismo-nav-left' aria-hidden='true'></i>",
                    "<i class='turismo-nav-right' aria-hidden='true'></i>"
                ],
                dots: true,
                center: true,
                margin: 0
            });
        };
        return {
            init: function () {
                _privateInit();
            }
        };
    })();
    (window["TurismoModules"] = window["TurismoModules"] || {})["Galeria"] = Galeria;
})();
/// <reference path="interfaces/module.ts" />
/// <reference path="../../node_modules/@types/jquery/index.d.ts"/>
(function () {
    "use strict";
    var General = (function () {
        var _timeoutId = null;
        var _privateAlertInit = function () {
            function createAlertCookie(cookieName, cookieValue, daysToExpire) {
                var date = new Date();
                date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
                document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toUTCString();
            }
            function accessAlertCookie(cookieName) {
                var name = cookieName + "=";
                var allCookieArray = document.cookie.split(';');
                for (var i = 0; i < allCookieArray.length; i++) {
                    var temp = allCookieArray[i].trim();
                    if (temp.indexOf(name) == 0)
                        return temp.substring(name.length, temp.length);
                }
                return "";
            }
            function checkAlertCookie() {
                var cookieName = $("#hidAlertPopup").val();
                var cookieValue = cookieName;
                var popupType = $("#hidPopupType").val();
                var val = accessAlertCookie(cookieName);
                if (val == "") {
                    $(popupType).show();
                    createAlertCookie(cookieName, cookieValue, 5);
                }
            }
            function alertBoxInit() {
                var element = $('.popup_alerta'), originalY = element.offset().top;
                // Space between element and top of screen (when scrolling)
                var topMargin = 20;
                // Should probably be set in CSS; but here just for emphasis
                element.css('position', 'relative');
                $(window).on('scroll', function (event) {
                    var scrollTop = $(window).scrollTop();
                    element.stop(false, false).animate({
                        top: scrollTop < originalY
                            ? 0
                            : scrollTop - originalY + topMargin
                    }, 0);
                });
                checkAlertCookie();
            }
            var $close_on_click = $('.nonflex-popup_alerta-fechar img');
            var mobileMaxWidth = "991px";
            if (window.matchMedia("(max-width: " + mobileMaxWidth + ")").matches) {
                $close_on_click = $('.nonflex-popup_alerta-fechar img, .nonflex-container');
            }
            $close_on_click.on('click tap', function () {
                $(".popup_alerta").css('display', 'none');
            });
            alertBoxInit();
        };
        var _privateInit = function () {
            var $headerElem = $(".header");
            var $topbarElem = $(".topbar");
            var $DeltaPageStatusBarElem = $("#DeltaPageStatusBar");
            $(window).scroll(function () {
                addFixed($(this));
            });
            $("#s4-workspace, .global-overlay").scroll(function () {
                addFixed($(this));
            });
            function addFixed(element) {
                if ($(element).scrollTop() < 57) {
                    $headerElem.removeClass("fixed-header");
                    $topbarElem.removeClass("scrolled");
                    $DeltaPageStatusBarElem.show();
                }
                else if (!$headerElem.hasClass('fixed-header')) {
                    $headerElem.addClass("fixed-header");
                    $topbarElem.addClass("scrolled");
                    $DeltaPageStatusBarElem.hide();
                }
            }
            $("#navTop").click(function () {
                $("html, body,#s4-workspace").animate({
                    scrollTop: 0
                }, 1000);
            });
            var $topMenuContainer = jQuery("#turismoTopNavMobile");
            $(".global-overlay").on("click mouseover", function (event) {
                if ($(event.currentTarget).hasClass("showin")) {
                    _timeoutId = setTimeout(function () {
                        var $openMenu = $(".item-child-open");
                        if ((!$(event.target).closest(".item-child-open").length && $('.openSearch').length === 0) && !$topMenuContainer.hasClass("open")) {
                            $openMenu.removeClass("item-child-open");
                            $("body").removeClass("overlay-open");
                            $(event.currentTarget).removeClass("showin");
                            if (!$(event.target).closest(".open-search-btn").length) {
                                $(".icon-search").removeClass("openSearch");
                                $(".overlay-placeholder").empty();
                                $(".top-navigation .sub-m-op").removeClass("sub-m-op");
                                $(".top-navigation .rollback-m").removeClass("rollback-m");
                                $(".global-overlay").removeClass("showin");
                                $(".overlay-placeholder").removeClass("open");
                                $("body").removeClass("overlay-open");
                            }
                        }
                    }, 6e2);
                }
            }).on("mouseout", function (event) {
                clearTimeout(_timeoutId);
            });
            $(".icon-search").click(function () {
                if (!$(".icon-search").hasClass("openSearch")) {
                    var $openMenu = $("#turismoTopNav > ul > li.tTN-menu-item.item-child-open");
                    $openMenu.removeClass("item-child-open");
                    showSearch($(this));
                }
                else {
                    hideSearch($(this));
                }
            });
            function showSearch($btn) {
                $btn.addClass("openSearch");
                $("body").addClass("overlay-open");
                $(".global-overlay").addClass("showin");
                $("#SearchInput").focus();
            }
            function hideSearch($btn) {
                $btn.removeClass("openSearch");
                $("body").removeClass("overlay-open");
                $(".global-overlay").removeClass("showin");
            }
            $(".box-toggle").click(function () {
                var boxTarget = $($(this).attr("box-toggle"));
                if (boxTarget.hasClass("in")) {
                    boxTarget.removeClass("in");
                    boxTarget.slideUp();
                }
                else {
                    boxTarget.addClass("in");
                    boxTarget.slideDown();
                }
                return false;
            });
        };
        return {
            init: function () {
                _privateInit();
            },
            clearTimeout: function () {
                clearTimeout(_timeoutId);
            },
            alertBox: function () {
                _privateAlertInit();
            }
        };
    })();
    (window["TurismoModules"] = window["TurismoModules"] || {})["General"] = General;
})();
/// <reference path="interfaces/module.ts" />
/// <reference path="../../node_modules/@types/jquery/index.d.ts"/>
(function () {
    "use strict";
    var MenuNavigation = (function () {
        //variable declaration
        var $bodyElem = $("body");
        var $globalOverlay = jQuery("#s4-bodyContainer .global-overlay");
        var $iconSearch = $(".icon-search");
        //mobile menu
        var $topMenuButton = jQuery("#topMenuButton>a");
        var $topMenuContainer = jQuery("#turismoTopNavMobile");
        var $topMenuItems = $topMenuContainer.children(".tTN-menu-item-mob");
        var menuOpen = false;
        var childMenuOpenArr = [];
        var _privateInit = function () {
            var menuItemsCount = $topMenuItems.length;
            for (var i = 0; i < menuItemsCount; i++) {
                childMenuOpenArr.push(false);
            }
            var $listItems = $("#turismoTopNav > ul > li"), $menuItems = $listItems.children("a:not('.openSearch')").not(".has-sub"), 
            // $itemsHasChilds: JQuery = $listItems.children("a.has-sub"),
            currentEl = -1;
            var _timeoutId;
            function actions() {
                $listItems.on("mouseenter click", "a.has-sub", open);
                $listItems.on("mouseenter", '.tTN-menu-child-inner', function () {
                    clearTimeout(_timeoutId);
                });
                // $menuItems.on("mouseover", close);
                // $itemsHasChilds.on("mouseleave", close);
                $(window).on("resize", close);
            }
            function open(event) {
                var _this = this;
                // const $globalOverlay: JQuery = $("#s4-bodyContainer .global-overlay");
                clearTimeout(_timeoutId);
                _timeoutId = setTimeout(function () {
                    window["TurismoModules"]["General"].clearTimeout();
                    if (!_this.classList.contains("has-sub")) {
                        return;
                    }
                    hideSearch();
                    if (currentEl !== -1) {
                        $listItems.eq(currentEl).removeClass("item-child-open");
                    }
                    var $item = $(event.currentTarget).parent("li"), itemIndex = $item.index();
                    var $subNavElem = $globalOverlay.find('.menuVisible').find($item).find('.tTN-menu-child');
                    $subNavElem.height("");
                    if (currentEl === itemIndex && event.type === "click") {
                        $item.removeClass("item-child-open");
                        $bodyElem.removeClass("overlay-open");
                        currentEl = -1;
                    }
                    else {
                        $globalOverlay.addClass("showin");
                        $item.addClass("item-child-open");
                        currentEl = itemIndex;
                        $bodyElem.addClass("overlay-open");
                        var distanceValues = $("#turismoTopNav>ul").offset();
                        $subNavElem.css("height", "calc(100vh - " + (distanceValues.top + 30) + "px");
                    }
                }, 6e2);
                return false;
            }
            function close(event) {
                _timeoutId = setTimeout(function () {
                    $listItems.eq(currentEl).removeClass("item-child-open").height("");
                    $("#turismoTopNav>ul").css("height", "auto");
                    $bodyElem.removeClass("overlay-open");
                    $("#s4-bodyContainer .global-overlay").removeClass("showin");
                    currentEl = -1;
                }, 3e2);
            }
            initMobileMenu();
            actions();
        };
        function initMobileMenu() {
            $topMenuButton.on("click", function (e) {
                e.preventDefault();
                toggleMenuTop();
                return false;
            });
            //close menu if click outside
            $(document).on('click', function (event) {
                if (!$(event.target).closest('nav#turismoTopNavMobile').length) {
                    closeMenuTop();
                }
            });
            $topMenuContainer.on("click", ".tTN-menu-item-mob", function (e) {
                var clickedElem = $(this);
                var hasSubElems = clickedElem.children(".has-sub");
                if (hasSubElems.length > 0) {
                    e.stopPropagation();
                    e.preventDefault();
                    window.requestAnimationFrame(function () {
                        toggleMenuItem(clickedElem);
                    });
                    return false;
                }
            });
            $topMenuContainer.on("click", ".tTN-menu-child-mob", function (e) {
                e.stopPropagation();
            });
            function toggleMenuItem(clickedElem) {
                var index = clickedElem.index();
                var childMenuOpen = childMenuOpenArr[index];
                childMenuOpen = !childMenuOpen;
                childMenuOpenArr.forEach(function (item, indexArr) {
                    childMenuOpenArr[indexArr] = false;
                });
                childMenuOpenArr[index] = childMenuOpen;
                window.requestAnimationFrame(function () {
                    if (childMenuOpen) {
                        var child = clickedElem.children(".tTN-menu-child-mob");
                        $topMenuItems.addClass("shrink-hide");
                        clickedElem.removeClass("shrink-hide");
                        clickedElem.addClass("item-child-open-mob");
                    }
                    else {
                        $topMenuItems.removeClass("shrink-hide");
                        clickedElem.removeClass("item-child-open-mob");
                    }
                });
            }
            function closeMenuTop() {
                menuOpen = false;
                $topMenuContainer.removeClass("open");
                $topMenuButton.removeClass("open");
            }
            function openMenuTop() {
                $topMenuContainer.addClass("open");
                $topMenuButton.addClass("open");
            }
            function toggleMenuTop() {
                menuOpen = !menuOpen;
                if (menuOpen) {
                    hideSearch();
                    showOverlay();
                    openMenuTop();
                }
                else {
                    closeMenuTop();
                    hideSearch();
                    hideOverlay();
                }
            }
        }
        function hideOverlay() {
            $globalOverlay.removeClass("showin");
            $bodyElem.removeClass("overlay-open");
        }
        function hideSearch() {
            $iconSearch.removeClass("openSearch");
        }
        function showOverlay() {
            $globalOverlay.addClass("showin");
            $bodyElem.addClass("overlay-open");
        }
        return {
            init: function () {
                $("ul.topbar-menu").flexMenu({
                    linkTextAll: $("ul.topbar-menu").attr("title"),
                    linkText: $("ul.topbar-menu").attr("title"),
                    linkTitle: $("ul.topbar-menu").attr("title"),
                    linkTitleAll: $("ul.topbar-menu").attr("title"),
                    showOnHover: true
                });
                _privateInit();
            }
        };
    })();
    (window["TurismoModules"] = window["TurismoModules"] || {})["MenuNavigation"] = MenuNavigation;
})();
/// <reference path="interfaces/module.ts" />
/// <reference path="../../node_modules/@types/jquery/index.d.ts"/>
(function () {
    "use strict";
    var PagerNoticias = (function () {
        var _initPager = function () {
            $('#ListaNoticias').on('click', '[id$=hlNextPage]', function (e) {
                e.preventDefault();
                var $target = $(e.target);
                $.get($target.data('nextpage'), function (response) {
                    var tempdiv = $('<div>');
                    var $response = $(response);
                    tempdiv.append($response);
                    var noticias = tempdiv.find("#ListaNoticias").children();
                    noticias.appendTo($("#ListaNoticias"));
                    window["__sharethis__"].initialize();
                });
                $target.remove();
            });
        };
        var _initFilter = function () {
            var $newsTagsContainer = $('.news-tags');
            var $tagElems = $newsTagsContainer.find('a.tag-item');
            $tagElems.on('click', function (e) {
                e.preventDefault();
                var $target = $(e.target);
                var targetFilter = $target.data('filter');
                if ($target.hasClass("active")) {
                    targetFilter = targetFilter.replace("tag=", "dummy");
                    $target.removeClass("active");
                }
                else {
                    $tagElems.removeClass("active");
                    $target.addClass("active");
                }
                $.get(targetFilter, function (response) {
                    var tempdiv = $('<div>');
                    var $response = $(response);
                    tempdiv.append($response);
                    var noticias = tempdiv.find("#ListaNoticias");
                    $("#ListaNoticias").html(noticias.html());
                    window["__sharethis__"].initialize();
                });
            });
        };
        var _privateInit = function () {
            _initPager();
            _initFilter();
        };
        return {
            init: function () {
                _privateInit();
            }
        };
    })();
    (window["TurismoModules"] = window["TurismoModules"] || {})["PagerNoticias"] = PagerNoticias;
})();
/// <reference path="interfaces/module.ts" />
/// <reference path="../../node_modules/@types/jquery/index.d.ts"/>
/// <reference path="../../node_modules/@types/sharepoint/index.d.ts" />
(function () {
    "use strict";
    var Pesquisa = (function () {
        var _privateInit = function () {
            $(".search-page").on("click", "#Paging a", function (event) {
                var $eventTarget = $(event.target);
                var nextPage = $eventTarget.data("paginginfo");
                //$("html, body,#s4-workspace").animate({
                //    scrollTop: $("#Result").offset().top
                //}, 2000);
                var resultsCtrl = $getClientControl(event.target);
                var $resultsElem = $(resultsCtrl.get_element());
                $resultsElem.css("visibility", "hidden");
                //$resultsElem.height($resultsElem.height());
                var $existingItems = $resultsElem.find('#Result .ms-srch-item').clone();
                resultsCtrl.add_resultRendered(function () {
                    $resultsElem.find(".ms-srch-group-content").prepend($existingItems);
                });
                resultsCtrl.page(Number($htmlEncode(nextPage)));
                return Srch.U.cancelEvent(event);
            });
            $(".search-page .filters").on("click", ".ms-ref-refiner h3", function (e) {
                var $currentTarget = $(e.currentTarget);
                var $overlayContent = $currentTarget.nextAll();
                var $tempDiv = $('<div>');
                $overlayContent.each(function (idx, obj) {
                    $tempDiv.append($(obj).clone());
                });
                var wrapperClass = "search-page";
                var overlayElem = $("#turismo-overlay");
                var overlaybody = $("#turismo-overlay").find(".modal-body");
                overlaybody.empty();
                var componentId = $currentTarget.parents("[componentid]").attr("componentid");
                overlaybody.addClass(wrapperClass).append("<div class='filters'><div componentid=" + componentId + ">" + $tempDiv.html() + "</div></div>");
                overlayElem.slideDown().addClass("in");
            });
            $("#turismo-overlay").on("click", ".close-modal, input", function () {
                var overlayContent = $("#filters").html();
                var wrapperClass = "search-page";
                var overlayElem = $("#turismo-overlay");
                var overlaybody = $("#turismo-overlay").find(".modal-body");
                overlayElem.slideUp().removeClass("in");
            });
            var advancedSearchTable = $('.srch-advancedtable');
            if (advancedSearchTable.length > 0) {
                var btnAdvancedSearch = $("<button id='btnAdvancedSearch' type='button' class='advanced-search-button'></button>");
                var lang = _spPageContextInfo.currentLanguage;
                var btnText = "Pesquisa avançada";
                if (lang == 1033) {
                    btnText = "Advanced search";
                }
                btnAdvancedSearch.text(btnText);
                btnAdvancedSearch.insertBefore(".advanced-search-zone");
            }
            var qsAdvSrchValue = GetUrlKeyValue("advsrch");
            if (qsAdvSrchValue == "1") {
                var divAdvSearch = $(".advanced-search-zone");
                if (divAdvSearch != null) {
                    divAdvSearch.removeClass("advanced-search-invisible");
                }
            }
            $(".search-page .advanced-search-area").on("click", "#btnAdvancedSearch", function (e) {
                var divAdvSearch = $(".advanced-search-zone");
                if (divAdvSearch != null) {
                    divAdvSearch.toggleClass("advanced-search-invisible");
                }
            });
        };
        return {
            init: function () {
                _privateInit();
            }
        };
    })();
    (window["TurismoModules"] = window["TurismoModules"] || {})["Pesquisa"] = Pesquisa;
})();
/// <reference path="../../node_modules/@types/jquery/index.d.ts"/>
(function prApoio() {
    "use strict";
    var selectLoc = null, selectEmp = null, selectInv = null, selectMont = null;
    var $selectedLoc, $selectedEmp, $selectedInv, $selectedMont;
    var $pageElem, $container, $listContainer;
    var filterUrl;
    var init = function () {
        $pageElem = $(".pr-apoio-page");
        $container = $pageElem.find(".container");
        $listContainer = $pageElem.find("#prApoioContainer");
        selectLoc = $container.find("select#pra-localizacao");
        selectEmp = $container.find("select#pra-empresa");
        selectInv = $container.find("select#pra-investimento");
        selectMont = $container.find("select#pra-montante");
        var $button = $container.find("#btnSearchPrApoio");
        $button.on("click", function (e) {
            e.preventDefault();
            return onCategorySelect(e);
        });
    };
    function showMore(e) {
        window["__sharethis__"].initialize();
        var $updatedListContainer = $pageElem.find("#prApoioContainer");
        var $btnShowMore = $updatedListContainer.find("#hlNextPage");
        if ($btnShowMore) {
            $btnShowMore.on("click", function (e) {
                e.preventDefault();
                var $linkElem = $(e.target);
                var paging = $linkElem.data("paging");
                var linkUrl = getLinkUrl($linkElem);
                $.ajax({
                    url: linkUrl + "&paging=" + paging,
                    type: 'GET'
                })
                    .then(function (response) {
                    $listContainer.append(response);
                    showMore(e);
                }, function handleError(error) {
                    $listContainer.html('<div>' + error.statusText + '</div>');
                });
                $btnShowMore.remove();
            });
        }
    }
    function onCategorySelect(e) {
        var $target = $(e.target);
        var $selectedOption = $target.find("option:selected");
        $selectedLoc = selectLoc.find("option:selected").val();
        $selectedEmp = selectEmp.find("option:selected").val();
        $selectedInv = selectInv.find("option:selected").val();
        $selectedMont = selectMont.find("option:selected").val();
        var linkUrl = getLinkUrl($target);
        $.ajax({
            type: 'GET',
            url: linkUrl
        })
            .then(function (response) {
            $listContainer.html(response);
            showMore(e);
        }, function handleError(error) {
            $listContainer.html('<div>' + error.statusText + '<div>');
        });
    }
    function getLinkUrl($ele) {
        var _linkUrl = $ele.data('filterurl') || filterUrl;
        filterUrl = _linkUrl;
        $selectedLoc = selectLoc.find("option:selected").val();
        $selectedEmp = selectEmp.find("option:selected").val();
        $selectedInv = selectInv.find("option:selected").val();
        $selectedMont = selectMont.find("option:selected").val();
        if ($selectedLoc) {
            _linkUrl += '&Loca=' + $selectedLoc + '';
        }
        if ($selectedEmp) {
            _linkUrl += '&Empr=' + $selectedEmp + '';
        }
        if ($selectedInv) {
            _linkUrl += '&Oper=' + $selectedInv + '';
        }
        if ($selectedMont) {
            _linkUrl += '&Mont=' + $selectedMont + '';
        }
        return _linkUrl;
    }
    ExecuteOrDelayUntilBodyLoaded(init);
})();
/// <reference path="interfaces/module.ts" />
/// <reference path="../../node_modules/@types/jquery/index.d.ts"/>
(function () {
    "use strict";
    var SliderAnalytics = (function () {
        var _showSlides = function (n) {
            var slideIndex = n - 1;
            var typesCollection = document.querySelectorAll(".type-header");
            for (var i = 0; i < typesCollection.length; i++) {
                var typesElement = typesCollection[i];
                var slidesCollection = typesElement.querySelectorAll(".mySlides");
                var dotsCollection = typesElement.querySelectorAll("mySlides_dot");
                for (var j = 0; j < slidesCollection.length; j++) {
                    var slideItem = slidesCollection[j];
                    if (j == slideIndex) {
                        slideItem.style.display = "block";
                    }
                    else {
                        slideItem.style.display = "none";
                    }
                }
                for (var k = 0; k < dotsCollection.length; k++) {
                    if (k != slideIndex) {
                        dotsCollection[k].className.replace(" active", "");
                    }
                }
            }
        };
        var _createNavigation = function () {
            var mySlidesDotDivCollection = document.querySelectorAll(".mySlides_dot_div");
            var nrOfBoardsPerTypeCollection = document.querySelectorAll('[class*="analytics-boards"]');
            for (var i = 0; i < nrOfBoardsPerTypeCollection.length; i++) {
                var nrOfBoardsItem = nrOfBoardsPerTypeCollection[i];
                var totalBoards = nrOfBoardsItem.dataset.total;
                var totalBoardsInt = parseInt(totalBoards);
                var mySlidesDotDivItem = mySlidesDotDivCollection[i];
                var _loop_1 = function (j) {
                    var dotSpanElement = document.createElement('span');
                    var item = j + 1;
                    dotSpanElement.onclick = function () { _showSlides(item); };
                    dotSpanElement.classList.add("mySlides_dot", "active");
                    mySlidesDotDivItem.appendChild(dotSpanElement);
                };
                for (var j = 0; j < totalBoardsInt; j++) {
                    _loop_1(j);
                }
            }
        };
        var _privateInit = function () {
            _createNavigation();
            _showSlides(1);
        };
        return {
            init: function () {
                _privateInit();
            }
        };
    })();
    (window["TurismoModules"] = window["TurismoModules"] || {})["SliderAnalytics"] = SliderAnalytics;
})();
/// <reference path="interfaces/module.ts" />
/// <reference path="../../node_modules/@types/jquery/index.d.ts"/>
(function () {
    "use strict";
    var SliderDestaque = (function () {
        var _privateInit = function () {
            $(".slider-carousel").owlCarousel({
                items: 1,
                lazyLoad: true,
                loop: true,
                autoplay: true,
                nav: true,
                video: false,
                navText: [
                    "<i class=\"turismo-nav-left\" aria-hidden=\"true\"></i>",
                    "<i class=\"turismo-nav-right\" aria-hidden=\"true\"></i>"
                ],
                dots: true,
                center: true,
                margin: 0
            });
        };
        return {
            init: function () {
                _privateInit();
            }
        };
    })();
    (window["TurismoModules"] = window["TurismoModules"] || {})["SliderDestaque"] = SliderDestaque;
})();
